export function resolveBaseURL() {
  if (process.env.REACT_APP_ENV === "production") {
    return process.env.REACT_APP_API_URL_PROD;
  }
  if (process.env.REACT_APP_API_BACKEND === "fastapi") {
    return process.env.REACT_APP_API_URL_FASTAPI_DEV || process.env.REACT_APP_API_URL_DEV;
  }
  return process.env.REACT_APP_API_URL_DEV;
}

export function resolveApiRoot() {
  return (resolveBaseURL() || "").replace(/\/api\/?$/, "");
}
